import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, Subject } from 'rxjs';

@Injectable()
export class AdvancedTextHandlerService {
    private currentElement: HTMLElement;

    constructor() {}

    setCurrent(newCurrent: HTMLElement) {
        this.currentElement = newCurrent;
    }

    getCurrent(): HTMLElement {
        return this.currentElement;
    }

    isRangeInElement(range: Range) {
        const current = this.getCurrent();
        const contains: any =
            range.startContainer.nodeType == 3 ? range.startContainer.parentNode : range.startContainer;
        return current.contains(contains) || current == contains;
    }

    private currentContentLangId$ = new BehaviorSubject<number>(undefined);
    setCurrentContentLangId(langId: number) {
        this.currentContentLangId$.next(langId);
    }
    getCurrentContentLangId(): Observable<number> {
        return this.currentContentLangId$.asObservable();
    }

    onClick$ = new Subject<MouseEvent>();
    onKeyup$ = new Subject<KeyboardEvent>();
}
